import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { PageLoader } from "src/components/page-loader"

const VerifyBuyer = () => {
  const { loginWithRedirect } = useAuth0();

  const { saleId } = useParams();

  useEffect(() => {
    if (saleId && saleId !== "") {
      handleLogin();
    }
  }, [saleId]);



  const handleLogin = useCallback(async () => {
    // Store sale information in localStorage before Auth0 redirect
    localStorage.setItem("checkout_sale_id", saleId ?? "");
    localStorage.setItem("checkout_redirect_status", "succeeded");
    localStorage.setItem("checkout_user_type", "buyer");

    await loginWithRedirect({
      appState: {
        returnTo: "/callback",
      },
      authorizationParams: {
        prompt: "login",
        screen_hint: "login",
      },
      openUrl: (url: string) => {
        window.location.href = url;
      },
    });
  }, [saleId, loginWithRedirect]);


  return <PageLoader />;
};

export default VerifyBuyer;
